var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Prop, Component } from 'vue-property-decorator';
import round from 'lodash/round';
import { sprintf } from 'sprintf-js';
import { addToCart } from 'ts/modules/cart';
let MouldingPopup = class MouldingPopup extends Vue {
    constructor() {
        super(...arguments);
        this.round = round;
    }
    get price() {
        return sprintf('%02.2f', parseFloat(this.moulding.price));
    }
    get numMetres() {
        return round(this.moulding.num_metres, 2);
    }
    get lengthSize() {
        return round(this.moulding.length.length_metres, 2);
    }
    get percentageDiscount() {
        return round(this.moulding.discount, 2);
    }
    get poundSaving() {
        let normalPrice = parseFloat(this.moulding.price) / (1 - (this.moulding.discount / 100));
        return sprintf('%02.2f', normalPrice - parseFloat(this.moulding.price));
    }
    get itemCode() {
        let dotIndex = this.moulding.sku.indexOf('.');
        return this.moulding.sku.substr(dotIndex + 1, this.moulding.sku.length - (dotIndex + 1));
    }
    addToCart() {
        addToCart({
            sku: `MLDS-${this.moulding.sku}`,
            qty: 1,
            attributes: {},
            price: this.moulding.ex_vat_price
        }).then(() => this.$bvModal.hide('moulding-popup'));
    }
};
__decorate([
    Prop(Object)
], MouldingPopup.prototype, "moulding", void 0);
MouldingPopup = __decorate([
    Component
], MouldingPopup);
export default MouldingPopup;
